import { EColors } from "libs/style/styling"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  children: React.ReactNode
  className?: string
}

export const TextBox = (props: Props): JSX.Element => {
  return <S_TextBox className={props.className}>{props.children}</S_TextBox>
}

const S_TextBox = styled.div`
  background-color: ${EColors.GREY2};
  width: 100%;
  height: 100%;
  border-radius: 7px;
`
